module.exports = __webpack_public_path__ + "static/img/photo3.a60535a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neuro/group2/photo3.png
// module id = oDDb
// module chunks = 0